Application.Postcard = {
    ready: function () {

        this.Background.ready(Application.Signature.PreviewList);
        this.Icon.ready(Application.Signature.PreviewList);
        this.Color.ready(Application.Signature.PreviewList);
        this.Message.ready(this.Postcard);
        this.Recipient.ready(this.Postcard);
        this.Loading.ready();
        this.Confirm.ready();

    }
};